export const OPENNETWORK_LOGS_RESET_STATE = 'OPENNETWORK_LOGS_RESET_STATE';
export const OPENNETWORK_LOGS_CURRENT_ITEM = 'OPENNETWORK_LOGS_CURRENT_ITEM';

export const OPENNETWORK_LOGS_REQUEST_LOADING = 'OPENNETWORK_LOGS_REQUEST_LOADING';
export const OPENNETWORK_LOGS_REQUEST_SUCCESS = 'OPENNETWORK_LOGS_REQUEST_SUCCESS';
export const OPENNETWORK_LOGS_REQUEST_FAILED = 'OPENNETWORK_LOGS_REQUEST_FAILED';

export const OPENNETWORK_LOGS_CURRENT_ACTION = 'OPENNETWORK_LOGS_CURRENT_ACTION';
export const OPENNETWORK_LOGS_RESET_ACTION = 'OPENNETWORK_LOGS_RESET_ACTION';